// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"d05e5335831705cf8d50","678":"860a76d1537b967a9052","774":"82deddad40da1774d4ce","883":"c041eb8d8209813ceab9"}[chunkId] + ".js";
};